<div class="collapse-wrapper" [ngClass]="'headerLayout-' + headerLayout()">
  @if (!isLayout12()) {
  <div class="title-section">
    <a class="mobile-category-menu" [target]="menuItem().target" [attr.data-click_action_value]="menuItem()['data-click_action_value']" [attr.data-click_action_choice]="menuItem()['data-click_action_choice']">
      <label (click)="hideMenu$.emit(true)">{{ menuItem().text }} </label>
    </a>

    <img [ngClass]="!collapsed() ? 'arrow-up' : 'arrow-down'" [src]="menuCollapseIcon()" class="down-arrow-icon" />
  </div>
  }

  <!-- Layout-12 specific HTML -->
  @if (isLayout12()) {
  <div class="title-section layout-12-specific">
    <div class="menu-item-content menu-item-main-container">
      <div class="menu-item-image-text-wrapper menu-item-image-anchor-container">
        <div class="combine-wrapper">
          <div class="menu-icon menu-item-image-container">
            <img [id]="menuItem().id" [src]="menuItem().categoryImage" class="category-image menu-item-category-image" [attr.data-click_action_value]="menuItem()['data-click_action_value']" [attr.data-click_action_choice]="menuItem()['data-click_action_choice']" />
          </div>

          <a class="mobile-category-menu static-header layout-12-menu" [target]="menuItem().target" [attr.data-click_action_value]="menuItem()['data-click_action_value']" [attr.data-click_action_choice]="menuItem()['data-click_action_choice']" [id]="menuItem().id">
            {{ menuItem().text }}
          </a>
        </div>
      </div>
      <img [ngClass]="!collapsed() ? 'arrow-up' : 'arrow-down'" [src]="menuCollapseIcon()" class="down-arrow-icon header-menu-collapse" />
    </div>
  </div>
  }

  <div [@collapse]="collapsed()">
    <ng-content></ng-content>
  </div>
</div>